import { Skeleton } from "@/components/ui/skeleton";

const PropertyCardSkeleton = () => (
  <div className="bg-card rounded-lg overflow-hidden shadow-card ring-1 ring-border/40">
    <Skeleton className="h-64 w-full rounded-none" />
    <div className="p-6 space-y-3">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-6 w-3/4" />
      <Skeleton className="h-5 w-32" />
      <Skeleton className="h-4 w-2/3" />
      <div className="flex flex-wrap gap-2 pt-2">
        <Skeleton className="h-4 w-14" />
        <Skeleton className="h-4 w-14" />
        <Skeleton className="h-4 w-14" />
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="flex flex-wrap gap-2 pt-1">
        <Skeleton className="h-6 w-16 rounded-full" />
        <Skeleton className="h-6 w-20 rounded-full" />
        <Skeleton className="h-6 w-14 rounded-full" />
      </div>
      <div className="flex gap-3 pt-3">
        <Skeleton className="h-10 flex-1 rounded-full" />
        <Skeleton className="h-10 flex-1 rounded-full" />
      </div>
    </div>
  </div>
);

export default PropertyCardSkeleton;
